<template>
  <span>
    <template v-if="isPreview">
      <div class="rcs-suggestion">
        <div v-if="value.type === 'dial'" class="material-symbols-outlined">call</div>
        <div v-if="value.type === 'location'" class="material-symbols-outlined">location_on</div>
        <div v-if="value.type === 'event'" class="material-symbols-outlined">calendar_month</div>
        <div v-if="value.type === 'url'" class="material-symbols-outlined">public</div>
        {{ value.text ? value.text : value.phoneNumber }}
      </div>
    </template>
    <template v-else>
      <InputComponent v-if="value.type === 'reply'" :placeholder="$tc('app.text')" v-model="value.text" :label="$tc('app.button_text')"> </InputComponent>
      <TelInputComponent v-else-if="value.type === 'dial'" :placeholder="$tc('app.text')" v-model="value.phoneNumber" :label="$tc('app.phone')"> </TelInputComponent>
      <div class="row" v-else-if="value.type === 'url'">
        <div class="col-md-6">
          <InputComponent :placeholder="$tc('app.text')" v-model="value.text" :label="$tc('app.button_text')" />
        </div>
        <div class="col-md-6">
          <InputComponent placeholder="URL" v-model="value.url" label="URL" />
        </div>
      </div>
      <div class="row" v-if="value.type === 'location'">
        <div class="col-md-6">
          <InputComponent :placeholder="$tc('app.text')" v-model="value.text" :label="$tc('app.button_text')" />
        </div>
        <div class="col-md-6">
          <InputComponent :placeholder="$tc('app.location')" v-model="value.address" :label="$tc('app.address')" required @focus="showMap = true" @blur="showMap = false">
          </InputComponent>
          <iframe
            v-if="showMap"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            id="gmap_canvas"
            :src="`https://maps.google.com/maps?amp;hl=en&amp;q=${value.address}&amp;t=&amp;z=19&amp;ie=UTF8&amp;iwloc=B&amp;output=embed`"
            width="300"
            height="400"
            frameborder="0"
          >
          </iframe>
        </div>
      </div>
      <div class="row" v-if="value.type === 'event'">
        <div class="col-md-4">
          <InputComponent :placeholder="$tc('app.text')" v-model="value.text" :label="$tc('app.button_text')" />
        </div>
        <div class="col-md-4">
          <InputComponent :placeholder="$tc('app.name')" v-model="value.title" :label="$tc('app.title')" />
        </div>
        <div class="col-md-4">
          <DateComponent v-model="value.date" :label="$tc('app.date')" />
        </div>
      </div>
    </template>
  </span>
</template>

<script>
import DateComponent from '../form/DateComponent.vue';
import InputComponent from '../form/InputComponent.vue';
import TelInputComponent from '../form/TelInputComponent.vue';

export default {
  name: 'RcsSuggestion',
  components: {
    InputComponent,
    TelInputComponent,
    DateComponent,
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({
        image: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
        title: '',
        description: '',
        buttons: [],
      }),
    },
  },
  data() {
    return {
      showMap: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.rcs-suggestion {
  border: 1px solid #e5e5e5;
  border-radius: 25px;
  padding: 10px;
  font-size: 14px;
  float: right;
  display: flex;
  margin: 0 5px 10px;
  white-space: nowrap;
  .material-symbols-outlined {
    font-size: 21px;
    vertical-align: top;
  }
}
iframe {
  position: absolute;
  bottom: 70px;
  right: 0;
}
</style>
